import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import FontSelectListItem from '../../shared/FontSelectListItem';

const LyricsFontListItem = (props) => {
    const { lyricsFont, updateLyricsStyle, searchGoogleFonts } = props;

    const onFontChange = (font, fontSource) => {
        updateLyricsStyle({ font, fontSource });
    };

    return (
        <FontSelectListItem
            value={lyricsFont}
            onChange={onFontChange}
            searchGoogleFonts={searchGoogleFonts}
        />
    );
};

const mapStateToProps = (state) => {
    const { font: lyricsFont } = state.createPreview.present.videoSettings.lyrics.style;
    return { lyricsFont };
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateLyricsStyle: (properties) => dispatch(createActions.updateLyricsStyle(properties)),
        searchGoogleFonts: (query, skip, take) => dispatch(createActions.searchGoogleFonts(query, skip, take))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsFontListItem);
